import { Rule, Throttle, Configuration, RuntimeConfigurationItem } from '../../../App/widgets';
import type { widgetRuleset } from './WidgetService.types';

export function parse(data: string): widgetRuleset {
    // console.log(data)
    var json = JSON.parse(data);
    console.log('json', json);
    var rules = json.rules as Rule[];
    console.log('parsed rules', rules);
    return {
        formsRules: function () {
            console.log('getting rules', rules);
            return rules.filter((rule: any) => rule.type == 'signup-form');
        },
        addRule(rule: Rule) {
            console.log('adding rule', rule);
            rules.push(rule);
            console.log('rules', rules);
        },
        serialize(): string {
            return JSON.stringify({ rules: rules });
        },
        newRule: function (id: string, type: string) {
            return { id: id, type } as Rule; //right now probablt redundant
        },
        remove: function (ownedByObjectId: string /*id: string*/) {
            // rules = [...rules.filter(rule => rule.id != id)]
            rules = [...rules.filter((rule) => rule.ownedByObjectId != ownedByObjectId)];
            console.log('__', ownedByObjectId, rules);
            return rules;
        },
    };
}
